var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{class:`min-width-icon ${_vm.customClass}`,attrs:{"variant":_vm.variant,"type":_vm.type,"disabled":_vm.disabled,"size":_vm.size},on:{"click":function($event){return _vm.handleClick($event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }